export default "__VITE_ASSET__CIpleCl9__"